import {
  Center,
  Grid,
  Group,
  Paper,
  Space,
  Stack,
  Text,
  Title,
} from '@mantine/core';
import { CircleCheck } from 'tabler-icons-react';
import StepperButton from '../../buttons/stepper.button/stepper.button';
interface ActivationStepProps {
  active: number;
  nextStep: () => void;
  prevStep: () => void;
  isLoading: boolean;
}
function ActivationStep(props: ActivationStepProps) {
  const { active, nextStep, prevStep, isLoading } = props;

  return (
    <>
      <Paper
        shadow='md'
        withBorder
        sx={{
          '@media (max-width: 755px)': {
            padding: 20,
          },
          '@media (min-width: 755px)': {
            padding: 100,
          },
        }}
      >
        <Grid justify='center'>
          <Grid.Col>
            <Title order={1} align='center' data-cy='welcome'>
              Welcome to{' '}
              <span>
                <img
                  alt='Xpay'
                  src='/images/xpay-dark.png'
                  style={{ maxHeight: 200, maxWidth: 200 }}
                ></img>
              </span>
            </Title>
          </Grid.Col>
          <Grid.Col>
            <Text mb={20} align='center'>
              In order to get you started, here are the steps that we will take.
              This will make sure that you will start accepting payments in no
              time!
            </Text>
          </Grid.Col>
        </Grid>
        <Space h='md' />
        <Center>
          <Stack>
            <Group noWrap>
              <CircleCheck />
              <Text align='left'>Activation</Text>
            </Group>
            <Group noWrap>
              <CircleCheck />
              <Text align='left'>Type of Business</Text>
            </Group>
            <Group noWrap>
              <CircleCheck />
              <Text align='left'>General Information</Text>
            </Group>
            <Group noWrap>
              <CircleCheck />
              <Text align='left'>Business Information</Text>
            </Group>
            <Group noWrap>
              <CircleCheck />
              <Text align='left'>
                Statement of <span>Acceptance</span>
              </Text>
            </Group>
          </Stack>
        </Center>
      </Paper>
      <StepperButton
        prevStep={prevStep}
        nextStep={nextStep}
        active={active}
        loading={isLoading}
      />
    </>
  );
}

export default ActivationStep;
